'use strict';

import {
  FileLoader, ImageBitmapLoader,
  LoadingManager, ObjectLoader,
  TextureLoader,
} from 'three';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader';
import { KTX2Loader } from 'three/examples/jsm/loaders/KTX2Loader';
import { threeJsVariables } from '../../../settings';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { MeshoptDecoder } from 'three/examples/jsm/libs/meshopt_decoder.module';
import { FBXLoader } from 'three/examples/jsm/loaders/FBXLoader';
import { LUTCubeLoader } from 'three/examples/jsm/loaders/LUTCubeLoader';
import { LazyTextureLoader } from './LazyTextureLoader';

export class Loader extends LoadingManager {
  static scopes = [];
  constructor () {
    super();
    this.totalPercent = 0;
    this.callbacks = [];
    this.onProgress = (url,itemsLoaded,itemsTotal) => {
      this.totalPercent = (itemsLoaded / itemsTotal * 100);
    };
    Loader.scopes.push(this);
  }

  set addCallback(f) {
    this.callbacks.push(f);
    this.onLoad = () => {
      this.callbacks.forEach(func => func());
    }
  }

  get textureLoader() {
    return new TextureLoader(this);
  }

  get lazyTextureLoader() {
    return new LazyTextureLoader(this);
  }

  get imageBitmapLoader() {
    const loader = new ImageBitmapLoader(this);
    loader.setOptions( { imageOrientation: 'flipY' } );
    return loader;
  }

  get fileLoader() {
    return new FileLoader(this);
  }

  get fbxLoader() {
    return new FBXLoader(this);
  }
  
  get objectLoader() {
    return new ObjectLoader(this);
  }

  get luteLoader() {
    this.totalPercent = 100;
    return new LUTCubeLoader();
  }

  get dracoLoader() {
    const dracoLoader = new DRACOLoader()
      .setDecoderPath('js/libs/gltf/');

    const ktx2Loader = new KTX2Loader()
      .setTranscoderPath( 'js/libs/basis/' )
      .detectSupport(threeJsVariables.renderer);

    return new GLTFLoader(this)
      .setDRACOLoader(dracoLoader)
      .setKTX2Loader(ktx2Loader)
      .setMeshoptDecoder( MeshoptDecoder );
  }

  get progress() {
    return this.totalPercent;
  }

  static totalProgress() {
    if (Loader.scopes.length === 0) return 0;
    return Loader.scopes.reduce((acc,scope) => acc += scope.progress,0) / Loader.scopes.length;
  }
}
